import React, { useState } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
// , useEffect import { motion } from 'framer-motion';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
// import { urlFor, client } from '../../client';
import './Testimonial.scss';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [testimonials, setTestimonials] = useState([]);
  // const [brands, setBrands] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const testimonials = [
    {
      name: 'Nrupendra Singh Rathore',
      company: 'Engineering Manager IV at Adobe.',
      imgurl: images.Nrupendra,
      feedback: 'Rajeesh had joined as ColdFusion developer, and with technology shift, he took the challenge of upskilling him in UI technologies and got a good command pretty fast. He is one of the coolest and calm person I have worked with who gets the work done without much noise. I would always be happy to have in my team.',
    },
    {
      name: 'Zahid Ali Shah Syed',
      company: 'Principal Program Manager at Adobe.',
      imgurl: images.Zahid,
      feedback: 'On the projects that Rajeesh & I worked together, he always displayed great technical knowledge, perseverance under challenging situations and willingness to go the extra mile when necessary. He is also a great team player.',
    },
    {
      name: 'Fraser Gregor',
      company: 'Software Development Engineer at Adobe.',
      imgurl: images.Fraser,
      feedback: "I've worked with Rajeesh on different projects over several years - he has always been a great asset to those projects. I enjoy working with Rajeesh - he's smart, adaptable, dedicated and very effective at coping with complex changes with minimal fuss. A highly valued team-mate.",
    },
    {
      name: 'Marcos Nowosad',
      company: 'Senior Software Engineer at Adobe',
      imgurl: images.Marcos,
      feedback: 'Though we were from different teams (and even time zones!) Rajeesh and I collaborated in many different projects at Adobe. Rajeesh always demonstrated being technically strong, having great professional attitude and helpful behavior. Our interactions were very smooth and productive, because Rajeesh was very proficient in the services and APIs we used in Adobe.',
    },
    {
      name: 'Raja Sarkarraj Sarkar',
      company: 'AD - Associate Director - Azure & Big Data at UBS Wealth Management.',
      imgurl: images.Raja,
      feedback: 'I worked with Rajeesh at Synova. He was an asset to the company. I had assigned many complex projects to him, but he completed them on time. He is very hard-working and technically exceptional. Other than his technical expertise, he was viewed as a nice person to work with. I would like to recommend him as a very strong technical architect who has the ability to make a big difference and add more value to UI technologies.',
    },
  ];

  // const brands = [
  //   {
  //     id: 'brand-1',
  //     imgUrl: images.adidas,
  //   },
  //   {
  //     id: 'brand-2',
  //     imgUrl: images.amazon,
  //   },
  //   {
  //     id: 'brand-3',
  //     imgUrl: images.bolt,
  //   },
  //   {
  //     id: 'brand-4',
  //     imgUrl: images.asus,
  //   },
  //   {
  //     id: 'brand-5',
  //     imgUrl: images.nb,
  //   },
  //   {
  //     id: 'brand-6',
  //     imgUrl: images.skype,
  //   },
  //   {
  //     id: 'brand-7',
  //     imgUrl: images.spotify,
  //   },
  // ];

  // useEffect(() => {
  //   const query = '*[_type == "testimonials"]';
  //   const brandsQuery = '*[_type == "brands"]';

  //   client.fetch(query).then((data) => {
  //     setTestimonials(data);
  //   });

  //   client.fetch(brandsQuery).then((data) => {
  //     setBrands(data);
  //   });
  // }, []);

  return (
    <>
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex">
            {/* <img src={urlFor(testimonials[currentIndex].imgurl)} alt={testimonials[currentIndex].name} /> */}
            <img src={testimonials[currentIndex].imgurl} alt={testimonials[currentIndex].name} />
            <div className="app__testimonial-content">
              <p className="p-text">{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>

            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      {/* <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={urlFor(brand.imgUrl)} alt={brand.name} />
            <img src={brand.imgUrl} alt={brand.name} />
          </motion.div>
        ))}
      </div> */}
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg',
);
